module.exports = __webpack_public_path__ + "static/seo-fitness-center-app-db85d678c6d9ea165d86c8f6ff0eeb3e.png";